
import {useAppSelector} from "../../store";

export function useCurrentMessage(): string | null {
    const id = useAppSelector((s) => s.messageChat.currentMessage);

    return (id != null) ? id : null;
}
